import { render, staticRenderFns } from "./universityList.vue?vue&type=template&id=74f95542&scoped=true&"
import script from "./universityList.vue?vue&type=script&lang=js&"
export * from "./universityList.vue?vue&type=script&lang=js&"
import style0 from "./universityList.vue?vue&type=style&index=0&id=74f95542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f95542",
  null
  
)

export default component.exports